import DV from 'ts-data-validator';

const phoneMasks = {
  1:  '+375 (##) ###-##-##',  // РБ
  2:  '+7 (###) ###-##-##',   // РФ
  3:  '+998-##-###-####',     // Узбекистан
  4:  '+373-####-####',       // Молдова
  5:  '+371-##-###-###',      // Латвия
  6:  '+996 (###) ###-###',   // Киргизстан
  7:  '+994-##-###-##-##',    // Азербайджан
  9:  '+40-##-###-####',      // Румыния
  10: '+386-##-###-###',      // Словения
  11: '+7 (###) ###-##-##',   // Казахстан
  12: '+370 (###) ##-###',    // Литва
  13: '+380 (##) ###-##-##',  // Украина
  14: '+995 (###) ###-###',   // Грузия
  15: '+420 (###) ###-###',   // Чехия
  16: '+1 (###) ###-####',    // США|Канада
  17: '+993-#-###-####',      // Туркменистан
  18: [                       // Объединенные Арабские Эмираты
    '+971-5#-###-####',
    '+971-#-###-####',
  ],
  19: '+45-##-##-##-##',      // Дания
  20: [                       // Германия
    '+49 (####) ###-####',
    '+49 (###) ###-####',
    '+49 (###) ##-####',
    '+49 (###) ##-###',
    '+49 (###) ##-##',
    '+49-###-###',
  ],
  21: [                       // Эстония
    '+372-####-####',
    '+372-###-####',
  ],
};

/**
 * @param {number} country
 * @param {string} phone
 * @return {boolean}
 */
export function checkValidityPhone(country, phone) {
  if (!country || !phone || !DV.isNotEmptyString(phoneMasks[country])) {
    return false;
  }

  const phoneMask  = phoneMasks[country];
  const cleanPhone = phone.replace(/\D+/g, '');

  const [code, sharp] = phoneMask.replace(/(?![0-9#])./g, '')
    .match(/\d+|#+/g);

  return new RegExp(`^${code}\\d{${sharp.length}}$`, 'g').test(cleanPhone);
}

/**
 * @param phone
 * @returns {number[]}
 */
export function getCountryIdsByPhone(phone) {
  if (!phone) {
    return [];
  }

  const cleanPhone = phone.replace(/\D+/g, '');
  const countryIds = [];

  const checker = (mask) => {
    const [code, sharp] = mask.replace(/(?![0-9#])./g, '')
      .match(/\d+|#+/g);

    return new RegExp(`^${code}\\d{${sharp.length}}$`, 'g').test(cleanPhone);
  };

  for (const countryId in phoneMasks) {
    const phoneMask = phoneMasks[countryId];

    if (DV.isArray(phoneMask)) {
      for (const subPhoneMask of phoneMask) {
        if (checker(subPhoneMask)) {
          countryIds.push(+countryId);
        }
      }
    } else if (DV.isString(phoneMask)) {
      if (checker(phoneMask)) {
        countryIds.push(+countryId);
      }
    }
  }

  return countryIds;
}

/**
 * @param {number} country
 * @param {string} phone
 * @return {string}
 */
export function preparePhoneNumber(country, phone) {
  if (checkValidityPhone(country, phone)) {
    const phoneMask  = phoneMasks[country];
    const cleanPhone = phone.replace(/\D+/g, '');
    const phoneArr   = cleanPhone.split('');

    phoneMask.split('')
      .forEach((char, charIndex) => {
        if (['+', ' ', '(', ')', '-'].includes(char)) {
          phoneArr.splice(charIndex, 0, char);
        }
      });

    return phoneArr.join('');
  } else {
    return phone;
  }
}